/*
 * @Author: atdow
 * @Date: 2024-01-08 11:31:36
 * @LastEditors: null
 * @LastEditTime: 2024-01-08 11:53:54
 * @Description: file description
 */
import { defineStore } from 'pinia'
import { SiteConfig } from '/@/stores/interface'

export const useSiteConfig = defineStore('siteConfig', {
  state: (): SiteConfig => {
    return {
      siteName: '瓴西',
      recordNumber: '',
      version: '',
      cdnUrl: '',
      apiUrl: '',
      upload: {
        mode: 'local',
        maxsize: 0,
        mimetype: '',
        savename: ''
      }
    }
  },
  actions: {
    dataFill (state: SiteConfig) {
      this.$state = state
    }
  }
})
